export const MAX_LEN_CLASS_NAME = 20;

export const DATA_SOURCES = {
    liveSessions: 'Video Sessions',
    capturedImagesAgent: 'Captured Images',
    magicMarker: 'Magic Marker'
};

export const DATA_TIME = {
    '': 'None',
    'week': 'Week',
    'month': 'Month',
    '3_months': '3 Months',
    '6_months': '6 Months',
    'year': 'Year'
};
